import type { UpdateRotaPattern } from '@lmc/ts-common'
import { postJSON } from 'common/services/api'
import { useMutation } from 'react-query'
import {
  getGenerateDescriptionPattern,
  type RotaPatternModalType
} from '../RotaPattern/utils'
import {
  ROTA_GENERATE_DESCRIPTION_URL,
  ROTA_PATTERN_DESCRIPTION_QUERY_KEY
} from './queryConstants'

type UseRotaPatternDescriptionProps = {
  type?: RotaPatternModalType
}

type UseRotaPatternDescriptionReturn = {
  generatePattern: (values: UpdateRotaPattern) => Promise<unknown>
  isLoadingGenerate?: boolean
  generatePatternMessage?: string
}

type Description = { description: string }

export const useRotaPatternDescription = ({
  type
}: UseRotaPatternDescriptionProps): UseRotaPatternDescriptionReturn => {
  // GENERATE DESCRIPTION PATTERN
  const generateFunction = async (
    values: UpdateRotaPattern
  ): Promise<Description> => {
    const patternGenerateValues = getGenerateDescriptionPattern({
      type,
      values
    })

    return postJSON({
      url: `${ROTA_GENERATE_DESCRIPTION_URL}`,
      method: 'POST',
      json: patternGenerateValues,
      isRota: true
    })
  }

  const {
    mutateAsync: generateMutation,
    isLoading: isLoadingGenerate,
    data: generatePatternData
  } = useMutation<Description, unknown, UpdateRotaPattern, unknown>(
    [ROTA_PATTERN_DESCRIPTION_QUERY_KEY],
    generateFunction
  )

  const handleGenerate = async (values: UpdateRotaPattern) => {
    try {
      const result = await generateMutation(values)
      return result
    } catch (err) {
      return err
    }
  }

  return {
    generatePattern: handleGenerate,
    isLoadingGenerate,
    generatePatternMessage: generatePatternData?.description
  }
}
